meedy.controller('meedy.homeController', ['$scope', '$state', '$mdToast', '$mdDialog', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel',
    function ($scope, $state, $mdToast, $mdDialog, objectHelper, applicationModel, userModel) {

        var today = new Date();
        today.setHours(0,0,0,0);

        var tommorow = new Date();
        tommorow.setDate(tommorow.getDate() + 1);
        tommorow.setHours(0,0,0,0);

        var selectedDate = today;

        function setData() {
            $scope.isTodaySelected = true;
            $scope.isTommorowSelected = false;

            Object.defineProperty($scope, 'selectedDate', {
                enumerable: true,
                configurable: false,
                get: function () {
                    return selectedDate;
                },
                set: function (val) {
                    selectedDate = val;
                    if(selectedDate) {
                        selectedDate.setHours(0,0,0,0);
                        if(selectedDate.getTime() === today.getTime()) {
                            $scope.isTodaySelected = true;
                        } else {
                            $scope.isTodaySelected = false;
                        }
                        if(selectedDate.getTime() === tommorow.getTime()) {
                            $scope.isTommorowSelected = true;
                        } else {
                            $scope.isTommorowSelected = false;
                        }
                        var criteria = new VisitDataGridCriteria();
                        criteria.dateFrom = selectedDate;
                        criteria.dateTo = angular.copy(selectedDate);
                        criteria.dateTo.setDate(selectedDate.getDate() + 1);
                        criteria.idDoctor = userModel.currentUser.id;
                        visitModel.getDataPage(criteria);
                    }

                }
            });

        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {
            $scope.setToday = function () {
                $scope.selectedDate = today;
            };

            $scope.setTommorow = function () {
                $scope.selectedDate = tommorow;
            };

        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.HOME);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.HOME_PAGE');
        }

        function initialize() {
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
